module.exports = __webpack_public_path__ + "img/msb.148a3fb0.png";